<div class="container">
<div class="card-container">
    <tm1-card variant = "shadow">
      <form id="addGate">
        <fieldset style="margin-bottom: 15px">
          <legend>Add Gate</legend>
          <span>
            <tm1-text-field ngDefaultControl appearance="filled" inputsize="regular" label="New Gate Name" labelposition=""
              helplabel="" (change)="onGateNameChange($event)" type="text"></tm1-text-field>
          </span>
          <br />
          <tm1-button [(ngModel)] = "newGateName" variant="solid" style="width: max-content" (click)="addGate()">
            Add Gate
          </tm1-button>
        </fieldset>
      </form>
    </tm1-card>
  </div>
  </div>